import { List,ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import TunnelIconResource from "../../assets/tunnel.svg"
import { Tunnel } from "../../services/RuteplanAPI";

export default function TunnelItem(props: IRoutePartProps) {

    return(
        <>
            {props.roadFeatures && props.roadFeatures.tunneler && props.roadFeatures.tunneler.length > 0 &&
            <List>
                {props.roadFeatures.tunneler.map((tunnel: Tunnel, index: number) => {
                    return (
                        <ListItem
                        key={tunnel.nvdbId + index}
                        className="roadFeature"
                        onClick={(event) => {props.onClick(tunnel, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(tunnel)}
                        onMouseLeave={props.onMouseLeaveItem}>                    
                            <img src={TunnelIconResource} alt="Tunnel icon" height="24" style={{paddingRight:"5px"}}/>
                            {"Tunnel: " + tunnel.nvdbId}                    
                        </ListItem>
                    )
                })}
            </List>
            }
        </>
    )
}